import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutOrderIdLookupAddStatus extends Layout {
    sourceOrdersLookupAddStatus: DataSource;
    table1: Table;
}
